import { useQuery } from "react-query"
import { getEventPerformances } from "../util/backend_api/event_performances"

export function useEventPerformancesForPost(postId, options = {}) {
  return useQuery(
    ["event_performances", postId],
    () => getEventPerformances(postId),
    {
      enabled: !!postId, // Only run query if postId exists
      retry: false,
      ...options,
    },
  )
}
